import React, { useState, useEffect, useCallback } from "react";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Skeleton from "react-loading-skeleton";
import axios from "axios";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Height } from "@mui/icons-material";
import { height } from "@mui/system";

const ProjectCard = ({ value }) => {
  // const {
  //   name,
  //   description,
  //   svn_url,
  //   stargazers_count,
  //   languages_url,
  //   language,
  //   pushed_at,
  // } = value;
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  {console.log(value)}
  return (
    <Col md={4} className="d-flex justify-content-center" style={{paddingTop:"25px"}}>
      <div class="card" style={{width: "73%", alignSelf:"start"}}>
        <img src={value.img} class="card-img-top" alt="..." style={{minHeight:"200px", maxHeight:"200px"}}></img>
        <div class="card-body mt-2">
          <h5 class="card-title text-center">{value.title}</h5>
          <div class="text-center mt-3">
          <Button variant="primary" onClick={handleShow}>
            About
          </Button>
          <a href={value.url} class="btn btn-primary ms-2" target="_blank" >Code/Demo</a>
          </div>
          

          <Modal show={show} onHide={handleClose}>
            <Modal.Header>
              <Modal.Title>{value.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{value.description}<br /> <br />{value.stack}</Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

        </div>
      </div>
    </Col>
  );
};

// const CardButtons = ({ svn_url }) => {
//   return (
//     <div className="d-grid gap-2 d-md-block">

//       <a href={svn_url} target=" _blank" className="btn btn-outline-secondary mx-2">
//         <i className="fab fa-github" /> Code
//       </a>
//     </div>
//   );
// };

// const Language = ({ languages_url, repo_url }) => {
//   const [data, setData] = useState([]);

//   const handleRequest = useCallback(async () => {
//     try {
//       const response = await axios.get(languages_url);
//       return setData(response.data);
//     } catch (error) {
//       console.error(error.message);
//     }
//   }, [languages_url]);

//   useEffect(() => {
//     handleRequest();
//   }, [handleRequest]);

//   const array = [];
//   let total_count = 0;
//   for (let index in data) {
//     array.push(index);
//     total_count += data[index];
//   }

//   return (
//     <div className="pb-3">
//       Languages:{" "}
//       {array.length
//         ? array.map((language) => (
//           <a
//             key={language}
//             className="card-link"
//             href={repo_url + `/search?l=${language}`}
//             target=" _blank"
//             rel="noopener noreferrer"
//           >
//             <span className="badge bg-light text-dark">
//               {language}:{" "}
//               {Math.trunc((data[language] / total_count) * 1000) / 10} %
//             </span>
//           </a>

//         ))
//         : "code yet to be deployed."}
//     </div>
//   );
// };

// const CardFooter = ({ star_count, repo_url, pushed_at }) => {
//   const [updated_at, setUpdated_at] = useState("0 mints");

//   const handleUpdatetime = useCallback(() => {
//     const date = new Date(pushed_at);
//     const nowdate = new Date();
//     const diff = nowdate.getTime() - date.getTime();
//     const hours = Math.trunc(diff / 1000 / 60 / 60);

//     if (hours < 24) {
//       if (hours < 1) return setUpdated_at("just now");
//       let measurement = hours === 1 ? "hour" : "hours";
//       return setUpdated_at(`${hours.toString()} ${measurement} ago`);
//     } else {
//       const options = { day: "numeric", month: "long", year: "numeric" };
//       const time = new Intl.DateTimeFormat("en-US", options).format(date);
//       return setUpdated_at(`on ${time}`);
//     }
//   }, [pushed_at]);

//   useEffect(() => {
//     handleUpdatetime();
//   }, [handleUpdatetime]);

//   return (
//     <p className="card-text">
//       <a
//         href={repo_url + "/stargazers"}
//         target=" _blank"
//         className="text-dark text-decoration-none"
//       >
//         <span className="text-dark card-link mr-4">
//           <i className="fab fa-github" /> Stars{" "}
//           <span className="badge badge-dark">{star_count}</span>
//         </span>
//       </a>
//       <small className="text-muted">Updated {updated_at}</small>
//     </p>
//   );
// };

export default ProjectCard;
